import { Component, inject, OnInit } from '@angular/core';
import { MarketplaceFacade } from '@fgb/core';

@Component({
  selector: 'fgb-events-page-v2',
  templateUrl: './events-page-v2.component.html',
  styleUrl: './events-page-v2.component.scss',
})
export class EventsPageV2Component implements OnInit {
  private marketplaceFacade = inject(MarketplaceFacade);

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItems();
  }
}
